module.exports = __webpack_public_path__ + "img/李勇.d297119c.png";